$(function(){
 
  var schoolCalc = $('#schoolCalculator');

  if(schoolCalc.length > 0) 
  {
    const setCountInputs = function() {

      const pupilsCountInput = $('#frm-CreateSchoolOrderForm-form-pupilsCount')
      const yearsCountInput = $('#frm-CreateSchoolOrderForm-form-yearsCount')
      
      const pupilsCount = pupilsCountInput.val();
      calcPrice(pupilsCount);

      setFreeTeachersLicences(pupilsCount)


      pupilsCountInput.on('change', 
        function() 
        {
          calcPrice();
          setFreeTeachersLicences()
        }
      );
      
      yearsCountInput.on('change', 
        function() 
        {
          calcPrice();
          setFreeTeachersLicences()
        }
      );



    }


    var calcPrice = function() {

      var smallClassCount = schoolCalc.attr('data-smallClassCount');

      const yearsCount = schoolCalc.find('#frm-CreateSchoolOrderForm-form-yearsCount').val();
      const pupilsCount = schoolCalc.find('#frm-CreateSchoolOrderForm-form-pupilsCount').val();



      if(parseInt(pupilsCount) <= parseInt(smallClassCount)) 
      {
        var discountPercentage = 0;
        var pricePerLicenceForSingleYear = schoolCalc.attr('data-smallClassPricePerLicence');
      } 
      else 
      {
        var pricePerLicenceForSingleYear = schoolCalc.attr('data-pricePerLicence');
        var discountPercentage = Math.round(getDiscountForCount(pupilsCount));
      }

      finalPriceForSingleYear = pricePerLicenceForSingleYear * pupilsCount;

      discount = roundByStep(finalPriceForSingleYear * (discountPercentage / 100), 0.50);
      finalPriceForSingleYear = finalPriceForSingleYear - discount;

      pricePerLicenceForSingleYear = Math.ceil(finalPriceForSingleYear / pupilsCount);

      const minimumPricePerLicence = schoolCalc.attr('data-minimumPricePerLicence');
      if(pricePerLicenceForSingleYear <= minimumPricePerLicence) { pricePerLicenceForSingleYear = minimumPricePerLicence; }

      finalPriceForSingleYear = Math.ceil(pricePerLicenceForSingleYear * pupilsCount); 

      const yearsDiscounts = [0, 10, 15, 20, 25];
      const yearsCountDiscountPercentage = yearsDiscounts[yearsCount - 1];

      const yearsCountDiscount = roundByStep(finalPriceForSingleYear * (yearsCountDiscountPercentage / 100), 0.50); 
      finalPrice = finalPriceForSingleYear - yearsCountDiscount;
      pricePerLicence = Math.ceil(finalPrice / pupilsCount);



      $('#discount-percentage-input').val(discountPercentage);
      $('#discount-currency-input').val(discount);
      $('#final-price-input').val(finalPriceForSingleYear);

      $('.licences-number').text(pupilsCount);
      $('.user-price').text(formatCurrency(pricePerLicenceForSingleYear));
      $('.final-price').text(formatCurrency(finalPriceForSingleYear));


      if(yearsCount > 1) 
      { 
        $('.years-discount-row').css('display', 'table-row'); 
        $('.teacher-licence-row').hide();
      }
      else { 
        $('.years-discount-row').hide(); 
        $('.teacher-licence-row').css('display', 'table-row');
      }

      $('.yearsCount').text(yearsCount);
      $('.yearsCountDiscountPercentage').text(yearsCountDiscountPercentage);
      $('.user-price-years').text(formatCurrency(pricePerLicence));
      $('.final-price-years').text(formatCurrency(finalPrice));

      const finalPriceText = yearsCount + " x " + formatCurrency(finalPrice) + " = <b>" + formatCurrency(finalPrice * yearsCount) + "</b>";
      $('.final-final-price').html(finalPriceText);
    }

    var getDiscountForCount = function(count) {

      var discounts = schoolCalc.attr('data-discounts').split(';');
      var usersForDiscount = schoolCalc.attr('data-usersForDiscount').split(';');

      var discount = 0;

      jQuery.each(usersForDiscount, function(i, usersCount) {

        if(parseInt(count) >= parseInt(usersCount)) 
        {
          discount = discounts[i];

          if(parseInt(count) <= parseInt(usersForDiscount[usersForDiscount.length - 1])) 
          {
            diffFromCountBaseline = count - usersCount;
            
            if(diffFromCountBaseline > 0) 
            {
              nextDiscount = discounts[i + 1];

              discountDiff = nextDiscount - discount;
              usersCountDiff = usersForDiscount[i + 1] - usersCount;
    
              discountPart = (discountDiff / usersCountDiff);
    
              discount = parseInt(discount) + discountPart * diffFromCountBaseline;
            }
          }
        }

      });

      return discount;
    }
  

    var formatCurrency = function(amount) {
      return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + $('.price-calculator').attr('data-currency');
    }



    var setupDontOrderInput = function() {

      var dontOrderInput = $('input[name="dontOrder"]');

      dontOrderFunction($('input[name="dontOrder"]:checked').val());

      dontOrderInput.on('change', function() 
      {
        dontOrderFunction($(this).val());
      });

    }

    var dontOrderFunction = function(isChecked) {

        var contactDataLine = $('#contactDataLine');
        var submitTranslations = $('#submit-translations');
        var invoiceDataContainer = $('#invoiceDataContainer');

        var icoInputContainer = $('#ico-input-container');

        var instutionName = $('#institution-name-container');
        
        if(isChecked == 1) 
        {
          invoiceDataContainer.hide();

          contactDataLine.attr('class', '');
          contactDataLine.addClass('margin-top-10');

          icoInputContainer.hide();
          instutionName.show();

          submitText = submitTranslations.attr('data-contact');

        } 
        else 
        {
          invoiceDataContainer.show();

          contactDataLine.attr('class', '');
          contactDataLine.addClass('margin-top-30');

          icoInputContainer.show();
          instutionName.hide();

          submitText = submitTranslations.attr('data-order');
        }

        $('#calc-submit').val(submitText)
    }

    var setFreeTeachersLicences = function(count) {

      var smallClassCount = schoolCalc.attr('data-smallClassCount');
      var isTeachersBonus = schoolCalc.attr('data-isTeachersBonus');

      if(count >= smallClassCount && isTeachersBonus) 
      {
        $('.teachersLicences.lessThan').hide();
        $('.teachersLicences.moreThan').show();
      } 
      else 
      {
        $('.teachersLicences.lessThan').show();
        $('.teachersLicences.moreThan').hide();
      }
    }



    setupDontOrderInput();
    setCountInputs();
  }
});



function roundByStep(value, step) {
  
  step || (step = 1.0);
  var inv = 1.0 / step;

  number = Math.round(value * inv) / inv;
  
  if(number % 1 !== 0) {
    number = number.toFixed(2);
  }
  
  return number;

}



